/**
 * Test utilities for adding data-testid attributes to components
 * Only used in development/test environments
 */

/**
 * Returns data-testid attribute if in development or test environment
 * This prevents test attributes from being included in production builds
 */
export const getTestId = (id: string) => {
  // Always return the data-testid attribute regardless of environment
  // This ensures tests can run in any environment
  return { 'data-testid': id };
};

/**
 * Returns data-testid attribute for question by type
 */
export const getQuestionTypeTestId = (questionType: string) => {
  return getTestId(`question-type-${questionType.toLowerCase().replace(/_/g, '-')}`);
};

/**
 * Returns data-testid attribute for a specific question type
 * Useful for targeting specific question components in tests
 */
export const getQuestionTestId = (questionType: string, id: string) => {
  return getTestId(`${questionType.toLowerCase().replace(/_/g, '-')}-${id}`);
};

/**
 * Returns data-testid attribute for a question option
 * Useful for targeting option elements in multiple choice/select questions
 */
export const getOptionTestId = (index: number) => {
  return getTestId(`option-${index}`);
};

/**
 * Returns data-testid attribute for a rating option
 * Useful for targeting rating elements
 */
export const getRatingTestId = (value: number) => {
  return getTestId(`rating-${value}`);
};

/**
 * Returns data-testid attribute for a boolean option
 * Useful for targeting boolean (yes/no, true/false) elements
 */
export const getBooleanTestId = (value: boolean | string) => {
  return getTestId(`boolean-${value}`);
};
